<nb-card [ngClass]="customNbCardClass">
    <nb-card-header>
        <div class="back-and-title">
            <div class="title" [innerHTML]="displayedTitle"></div>
            <i
              class="fas fa-times fa-xl cancel-btn"
              (click)="close()"
            ></i>
        </div>
    </nb-card-header>

    <nb-card-body class="elements-list-body">
        @if (currentMode() === 'links') {
            <div class="linked-elements-container" [nbSpinner]="allElementsLoading()">
                <div class="elements-list">
                    @for (elt of linkedElements(); track elt.id) {
                        <div class="list-item linked-item mode-links" [class.current-investment]="elt.id === mainInvestmentId">
                            <ng-container *ngTemplateOutlet="investmentCard; context: { elt, mode: 'links' }"></ng-container>
                        </div>
                    } @empty {
                    }
                </div>
            </div>

            <!-- FAB BUTTON WITH POPOVER -->
            @if (showLinkButton()) {
                @if (menuMode === 'initiative') {
                    <div class="initiative-attach-menu-container">
                        <button
                            id="linkable-investments-add-choice-fab"
                            class="add-link-fab"
                            (click)="toggleAttachMenu()"
                        >
                            <i class="fal fa-link"></i>
                        </button>
                        @if (showAttachMenu) {
                            <div class="attach-menu-popup">
                                <div class="attach-menu-item" (click)="setSearchMode()">
                                    {{ "Attach an existing investment to the action" | translate }}
                                </div>
                                <div class="attach-menu-divider"></div>
                                <div class="attach-menu-item" (click)="openNewInvestment()">
                                    {{ "Attach a new investment to the action" | translate }}
                                </div>
                            </div>
                        }
                    </div>
                } @else {
                    <button
                        id="linkable-investments-add-choice-fab"
                        class="add-link-fab"
                        (click)="setSearchMode()"
                    >
                        @if (!linkedToId) {
                            <i class="fal fa-arrow-up-right-from-square" aria-hidden="true"></i>
                        }
                    </button>
                }
            }
        } @else if (currentMode() === 'search') {
            <!-- SEARCH VIEW -->
            <div class="search-mode-container" [nbSpinner]="allElementsLoading()">
                <div class="search-bar-header">
                    <div class="search-input-wrapper">
                        <i class="fas fa-search search-icon"></i>
                        <input
                            nbInput
                            id="linkable-investments-search-input"
                            type="text"
                            placeholder="{{ 'Search' | translate }}"
                            [ngModel]="searchValue()"
                            (ngModelChange)="search($event)"
                            class="full-width-search"
                        >
                    </div>
                </div>

                <div class="search-results-list">
                    @if (!allElementsLoading()) {
                        @for (elt of notLinkedElementsAfterFilter(); track elt.id) {
                            <div
                              class="list-item search-result-item"
                              [class.selected]="selectedIds().includes(elt.id)"
                              [class.is-already-linked]="!asset && !!$any(elt).linked_to"
                              [title]="!asset && !!$any(elt).linked_to ? ('This investment is already linked to another investment' | translate) : ''"
                              (click)="toggleInvestmentSelection(elt.id)"
                            >
                              <ng-container *ngTemplateOutlet="investmentCard; context: { elt, mode: 'search' }"></ng-container>
                            </div>
                        } @empty {
                            <div class="no-data text-center pt-4">
                                <span>{{ "No investment" | translate }}</span>
                            </div>
                        }
                    }
                </div>

                <!-- ADD BUTTON FAB -->
                @if (selectedIds()?.length && multipleChoice) {
                    <button
                        id="linkable-investments-save-links-fab"
                        class="add-link-fab plus-fab"
                        (click)="linkElements()"
                    >
                        <i class="fal fa-plus"></i>
                    </button>
                }
            </div>
        }
    </nb-card-body>
</nb-card>

<!-- SHARED INVESTMENT CARD TEMPLATE -->
<ng-template #investmentCard let-elt="elt" let-mode="mode">
    <div class="investment-search-card">
        @if (mode === 'links') {
            @if (elt.id === (linkedToId || mainInvestmentId)) {
                <!-- Main investment -->
                <div class="role-icon role-icon--main" title="{{ 'Main investment' | translate }}">
                    <img src="/assets/icons/LinkIn.svg" aria-hidden="true" alt="">
                </div>
            } @else {
                <!-- Secondary investment -->
                <div class="role-icon role-icon--secondary" title="{{ 'Complementary investment' | translate }}">
                    <img src="/assets/icons/LinkOut.svg" aria-hidden="true" alt="">
                </div>
            }
        }
        <div class="investment-content" (click)="openInvestmentForm(elt.id)">
            <div class="investment-name">{{ elt.label }}</div>
            <div class="investment-details">
                <span class="investment-status">{{ "Status" | translate }}: {{ elt.status_object?.name }}</span>
                <span class="investment-budget">{{ getBudgetDisplay(elt) }}</span>
                @if (getRoadmapIndicatorsString($any(elt))) {
                    <span class="investment-impact">{{ "Impact" | translate }}: {{ getRoadmapIndicatorsString($any(elt)) }}</span>
                }
            </div>
        </div>
        @if (mode === 'links' && elt.id !== mainInvestmentId) {
            <div class="investment-icon" (click)="removeLinkedElement(elt.id)"
                [class.disabled]="readOnly"
                title="{{ (readOnly ? 'Cannot unlink from complementary view' : 'Unlink investment') | translate }}"
            >
                <i class="fa-light fa-link-slash"></i>
            </div>
        }
    </div>
</ng-template>
